import React from 'react'

import { Skeleton } from 'components'
import {
  SKELETON_INFO,
  SKELETON_ADDRESS,
  SKELETON_CONTACT,
} from 'features//Branch/constants'
import { BoxItem, BoxAddressItem, BoxDetailItem } from './BranchDetail'

const SkeletonBranchDetail: React.FC = () => {
  const base = 'f-branch-detail'

  const SkeletonInfo = () => {
    return (
      <div className={`${base}__branch-info-content`}>
        <div className={`${base}__title-layout`}>
          <span className={`${base}__branch-detail-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </span>
        </div>
        <div className={`${base}__description-layout`}>
          {SKELETON_INFO.map((data, index) => {
            return (
              <BoxItem
                key={index}
                title={<Skeleton.whiteSkeleton width={`${data.widthTitle}`} />}
                description={
                  <Skeleton.whiteSkeleton width={`${data.widthDescription}`} />
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  const SkeletonAddress = () => {
    return (
      <div className={`${base}__branch-address-content`}>
        <div className={`${base}__title-layout`}>
          <span className={`${base}__branch-detail-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </span>
        </div>
        <div>
          <div className={`${base}__description-layout`}>
            <BoxAddressItem
              title={<Skeleton.whiteSkeleton width='74px' />}
              description={
                <>
                  <Skeleton.whiteSkeleton height='18px' width='121px' />
                  <Skeleton.whiteSkeleton height='18px' width='245px' />
                </>
              }
            />
            {SKELETON_ADDRESS.map((data, index) => {
              return (
                <BoxItem
                  key={index}
                  title={
                    <Skeleton.whiteSkeleton width={`${data.widthTitle}`} />
                  }
                  description={
                    <Skeleton.whiteSkeleton
                      width={`${data.widthDescription}`}
                    />
                  }
                />
              )
            })}
          </div>
          <BoxDetailItem
            title={<Skeleton.whiteSkeleton width='74px' />}
            description={<Skeleton.whiteSkeleton width='121px' />}
          />
        </div>
      </div>
    )
  }

  const SkeletonContact = () => {
    return (
      <div className={`${base}__branch-contact-content`}>
        <div className={`${base}__title-layout`}>
          <span className={`${base}__branch-detail-title`}>
            {<Skeleton.whiteSkeleton width='130px' />}
          </span>
        </div>
        <div className={`${base}__description-layout`}>
          {SKELETON_CONTACT.map((data, index) => {
            return (
              <BoxItem
                key={index}
                title={<Skeleton.whiteSkeleton width={`${data.widthTitle}`} />}
                description={
                  <Skeleton.whiteSkeleton width={`${data.widthDescription}`} />
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div data-testid='skeleton-loading'>
      <SkeletonInfo />
      <SkeletonAddress />
      <SkeletonContact />
    </div>
  )
}

export default SkeletonBranchDetail
